export default {
  header: {
    blNoTitle: '提单号 (B/L)',
    copyOrder: '复制订单',
    viewAllOrders: '查看全部订单',
    customer: '客户',
    cargoName: '货名',
    weight: '重量',
    volume: '体积',
    containerQty: '箱量',
    vehicleUnit: '辆',
    containerUnit: '柜'
  },
  businessInfo: {
    containerSection: '箱货信息',
    noTemplateTitle: '未配置视图模板',
    noTemplateSubtitle: '该业务类型尚未发布视图模板，请联系管理员在平台端配置并发布。',
    noDataTitle: '暂无业务信息',
    noDataSubtitle: '该订单暂无可显示的业务信息',
    columns: {
      type: '箱型',
      containerNo: '箱号',
      sealNo: '封号',
      tareWeight: '皮重 (kg)',
      vgm: 'VGM (kg)',
      packageCount: '件数',
      grossWeight: '毛重 (kg)',
      volume: '体积 (m³)',
      status: '箱状态'
    },
    containerStatus: {
      packed: '已装箱',
      inPort: '已进港',
      loaded: '已装船',
      discharged: '已卸船',
      returned: '已还箱'
    }
  },
  timeline: {
    businessTab: '业务动态',
    logisticsTab: '物流动态',
    time: '时间',
    description: '说明',
    noBusiness: '暂无业务动态',
    noLogistics: '暂无物流动态',
    contactHint: '如需开通物流追踪服务，请联系 WallTech 客服'
  }
}
